"use client";

import { Icon, PillStatut } from "@/components/Icons";
import { useStock } from "@/context/StockContext";
import { euro, nb, statut } from "@/lib/utils";
import type { FiltreStock } from "@/lib/types";

export function StockView() {
  const {
    produits,
    filtre,
    setFiltre,
    allee,
    setAllee,
    recherche,
    setRecherche,
    ouvrirPanel,
  } = useStock();

  const q = recherche.trim().toLowerCase();
  const rows = produits.filter((p) => {
    if (filtre === "bas" && statut(p) !== "bas") return false;
    if (filtre === "rupture" && statut(p) !== "rupture") return false;
    if (allee !== "toutes" && !p.emp.startsWith(allee)) return false;
    if (q && !(p.ref + " " + p.nom + " " + p.emp).toLowerCase().includes(q)) return false;
    return true;
  });

  const chip = (id: FiltreStock, lib: string) => (
    <button
      key={id}
      className="chip"
      type="button"
      aria-pressed={filtre === id}
      onClick={() => setFiltre(id)}
    >
      {lib}
    </button>
  );

  return (
    <>
      <div className="toolbar">
        <div className="search">
          <Icon name="search" />
          <input
            type="search"
            placeholder="Référence, désignation, emplacement…"
            value={recherche}
            aria-label="Rechercher"
            onChange={(e) => setRecherche(e.target.value)}
          />
        </div>
        <div className="chips">
          {chip("tous", "Tous")}
          {chip("bas", "Sous le seuil")}
          {chip("rupture", "Rupture")}
        </div>
        <select
          aria-label="Allée"
          value={allee}
          onChange={(e) => setAllee(e.target.value)}
        >
          {["toutes", "A", "B", "C"].map((a) => (
            <option key={a} value={a}>
              {a === "toutes" ? "Toutes les allées" : `Allée ${a}`}
            </option>
          ))}
        </select>
      </div>
      <p className="muted" style={{ fontSize: ".86rem", marginBottom: 8 }}>
        {rows.length} article{rows.length > 1 ? "s" : ""} ·{" "}
        {nb(rows.reduce((s, p) => s + p.qte, 0))} unités
      </p>
      <div className="tbl-wrap">
        <table>
          <thead>
            <tr>
              <th>Article</th>
              <th>Emplacement</th>
              <th className="r">Stock</th>
              <th className="r hide-s">Seuil</th>
              <th className="r hide-s">Valeur</th>
              <th>État</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((p) => (
                <tr
                  key={p.ref}
                  className="click"
                  tabIndex={0}
                  onClick={() => ouvrirPanel(p.ref)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") ouvrirPanel(p.ref);
                  }}
                >
                  <td>
                    <span className="name">
                      {p.nom}
                      <small className="mono muted">{p.ref}</small>
                    </span>
                  </td>
                  <td>
                    <span className="loc">{p.emp}</span>
                  </td>
                  <td className="r">
                    <span className="qty">{p.qte}</span>
                  </td>
                  <td className="r num muted hide-s">{p.seuil}</td>
                  <td className="r num hide-s">{euro(p.qte * p.pa)}</td>
                  <td>
                    <PillStatut statut={statut(p)} />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="muted" style={{ padding: 28, textAlign: "center" }}>
                  Aucun article ne correspond.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
